import { Col, StopIcon, SuccessIcon, Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";
import { EmailField } from "./EmailField";

import { useState } from "react";

import { TableCellLink } from "../table/TableCellLink";
import { useEmailHistory } from "../../hooks/emailhistory/useEmailHistory";
import { EmailHistoryListFilter } from "./EmailHistoryListFilter";
import { EmailPreviewDrawer } from "./drawer/EmailPreviewDrawer";
import { ControlcenterMelcoModelsEmailListItem } from "melco-shared-logic";

export const EmailHistoryList: React.FC = () => {
  const { t } = useTranslation();
  const [isEmailPreviewDrawerOpen, setEmailPreviewDrawerOpen] = useState(false);
  const [emailRowObject, setEmailRowObject] = useState();
  //const [type, setType]=useState("password");

  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    filtersChange,
  } = useEmailHistory();

  const columns = [
    {
      title: t("emailhistory.table.column.is_email_sent"),
      key: "is_email_sent",
      //dataIndex: "is_email_sent",
      render: (rowObj: ControlcenterMelcoModelsEmailListItem) => {
        return <>{rowObj.is_email_sent ? <SuccessIcon /> : <StopIcon />}</>;
      },
      // sorter: true,
      width: 150,
    },
    {
      title: t("emailhistory.table.column.id"),
      key: "id",
      // dataIndex: "id",
      sorter: true,
      width: 350,
      render: (rowObj: ControlcenterMelcoModelsEmailListItem) => (
        <TableCellLink
          onClick={() => {
            handleEmailPreviewClick(rowObj);
          }}
          to={""}
        >
          {rowObj.id}
        </TableCellLink>
      ),
    },

    {
      title: t("emailhistory.table.column.emailaddress"),
      key: "email_address",
      dataIndex: "email_address",
      sorter: true,
      width: 350,
      render: (rowObj: any) => {
        return (
          <>
            {/* <input 
                    type={type}
                    onClick={(e)=> {
                        console.log(e);
                    }
                    }
                    value={type==="password"?"******":rowObj} 
                    style={{border:"none",width:"100%"}}
                /> */}
            <EmailField email={rowObj} />
            {/* <span>
                    {show == rowObj.email_address ? rowObj.email_address : "*********************"}
                </span> */}
          </>
        );
      },
    },
    {
      title: t("emailhistory.table.column.senttimestamp"),
      key: "time_stamp",
      // dataIndex: "timeStamp",
      sorter: true,
      width: 350,
      render: (rowObj: any) => (
        <div>
          <span>
            {rowObj.time_stamp
              ? new Date(rowObj.time_stamp).toLocaleString()
              : ""}
          </span>
        </div>
      ),
    },
  ];

  const handleEmailPreviewClick = (rowObj: any) => {
    setEmailRowObject(rowObj);
    setEmailPreviewDrawerOpen(true);
  };

  const setDrawerAction = (action: boolean) => {
    setEmailPreviewDrawerOpen(action);
  };

  return (
    <>
      <TableActionBarRow>
        <div></div>
        <Col>
          {/* <Search
                        onSearchInputChange={(query: string) => searchQueryChange(query)}
                    /> */}
          <EmailHistoryListFilter onFiltersChange={filtersChange} />
        </Col>
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="id"
        // rowSelection={rowSelection}
        // onRow={onRow}
        noDataMessage={t("emailhistory.no_data_message")}
        errorComponent={errorComponent}
      />

      {isEmailPreviewDrawerOpen && emailRowObject && (
        <EmailPreviewDrawer
          isDrawerOpen={isEmailPreviewDrawerOpen}
          setDrawerOpen={setDrawerAction}
          emailRowObject={emailRowObject}
        />
      )}
    </>
  );
};
